
import Highlighter from 'react-highlight-words';
import { getMasterList } from '../../../Utils/FormCalls';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import StyledTable from "../../../../../commons/styles/table";
import { Input, Modal, Button } from 'antd';
import { UploadOutlined, SearchOutlined } from '@ant-design/icons';
import { API_MASTERFAILURECODES } from '../../../../../commons/api';

const urlList = {
  list: API_MASTERFAILURECODES.Hierarchy
};

const SelectNestedComponent = (props) => {
  const [currentOption, setCurrentOption] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const [current, setCurrent] = useState(1);
  const [failureHierarcy, SetFailureHierarcy] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);


  useEffect(() => {
    const fetchData = async () => {
      const currentOptionData = await getMasterList(urlList.list);
      setCurrentOption(currentOptionData);
    };
    fetchData();
  }, [failureHierarcy]);

  const openModal = () => {
    SetFailureHierarcy(true);
    setVisible(true);
  };

  const handleCancel = () => {
    SetFailureHierarcy(false);
    setVisible(false);
    setSelectedValue([]);
    setCurrent(1);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current.select());
        }
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const columns = [
    {
      title: translation(props.translationCache, 'Failure Class'),
      dataIndex: 'value',
      key: 'value',
      ...getColumnSearchProps('value')
    },
    {
      title: translation(props.translationCache, 'Type'),
      dataIndex: 'Type',
      key: 'Type',
      ...getColumnSearchProps('Type')
    },
    {
      title: translation(props.translationCache, 'Description'),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(props.translationCache, 'Remarks'),
      dataIndex: 'Remarks',
      key: 'Remarks'
    }
  ];

  return (
    <div style={{ margin: "10px 0px" }}>
      <span>
        <Input
          style={{ width: '20%', flex: '30%' }}
          placeholder={translation(props.translationCache, 'Select Failure Class')}
          value={props.text && props.text !== '' ? props.text : undefined}
        />
        <UploadOutlined
          onClick={openModal}
          style={{ cursor: 'pointer', color: 'white', fontSize: "18px" }}
        />
      </span>
      <Modal
        title={
          currentOption && currentOption[0] && currentOption[0]['Type']
            ? translation(props.translationCache, `Select ${currentOption[0]['Type']}`)
            : translation(props.translationCache, 'Select')
        }
        open={visible}
        footer={null}
        closable
        onCancel={handleCancel}
      >
        {currentOption && Array.isArray(currentOption) && currentOption.length > 0 ? (
          <StyledTable size="small"
            key={current}
            dataSource={currentOption}
            columns={columns}
            onRow={(record) => ({
              onClick: () => {
                const newSelectedValue = [...selectedValue, record];
                setSelectedValue(newSelectedValue);
                setCurrentOption(record.child || []);
                setCurrent(current + 1);
                if (current === 4) {
                  handleCancel();
                  props.NestedSelectOnChange(newSelectedValue, 'FailureCodes');
                }
              }
            })}
          />
        ) : (
          <div>No data</div>
        )}
      </Modal>
    </div>
  );
};

export default SelectNestedComponent;